"use client";

import { ArrowRight, Building2, Check, MapPin, Truck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Industrialcapabilities() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    icon: Truck,
    title: "Mechanical Installation",
    description: "Precision millwright services and heavy machinery installation. Our expert team ensures your equipment is set, aligned, and ready for operation.",
    features: ["Precision laser alignment", "Heavy machinery rigging", "Certified safety protocols"],
    popular: false,
    to: "/ServicesPage"
  }, {
    icon: MapPin,
    title: "Process Piping",
    description: "High-quality industrial piping systems designed for efficiency and durability. We handle complex installations for diverse manufacturing environments.",
    features: ["Custom fabrication services", "High-pressure system testing", "Strict code compliance"],
    popular: true,
    to: "/ServicesPage"
  }, {
    icon: Building2,
    title: "General Construction",
    description: "Comprehensive industrial construction solutions. From structural steel to facility upgrades, we deliver projects on time and within budget.",
    features: ["Structural steel erection", "Facility maintenance support", "Fully licensed and insured"],
    popular: false,
    to: "/ServicesPage"
  }];
  return;
}